/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");


const template = require('../../community/topic-list.tpl');

const topicListMixin = require('../../community/topicListMixin');
const GeneralTopic = {
	mixins: [topicListMixin],
	template,

	data() {
		return {
			thItems: ["话题标题","显示位置","话题链接与ID","话题时间","话题状态","浏览量","发帖量","操作"],
			thItemSort:[
				{
					txt:'话题标题',
					isSort:0
				},
				{
					txt:'显示位置',
					isSort:0
				},
				{
					txt:'话题链接与ID',
					isSort:0
				},
				{
					txt:'话题时间',
					isSort:0
				},
				{
					txt:'话题状态',
					isSort:0
				},
				{
					txt:'浏览量',
					isSort:1,
					keys:'browse',
					sortVal:4
				},
				{
					txt:'发帖量',
					isSort:1,
					keys:'post',
					sortVal:5
				},
				{
					txt:'操作',
					isSort:0
				},
			],
			type:1,
			topicAddName:"generaltopicadd",
			addBtnName:"+ 新增互动话题",
			queryOpt:{'type':1},
		}
	}
}

module.exports = GeneralTopic;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/community/general-topic/general-topic-list/general-topic-list.js